import { Button } from "@mui/material";

/**
 * A standardized icon button component for task-related actions
 *
 * @param {Object} props - Component properties
 * @param {string} props.text - Button text label
 * @param {string} props.color - Button color (primary, secondary, error, etc.)
 * @param {React.ReactNode} props.icon - Icon component to display at start of button
 * @param {Function} props.onClick - Click handler function
 * @param {Object} [props.sx] - Optional additional styles to apply
 * @returns {JSX.Element} Styled button component with icon
 */
function TaskIconButton({ text, color, icon, onClick, sx = {} }) {
  return (
    <Button variant="outlined" color={color} startIcon={icon} sx={{ py: 1, ml: 1, ...sx }} onClick={onClick}>
      {text}
    </Button>
  );
}

export default TaskIconButton;
